
import PromotionBanner from '@/graphql/queries/promotions/PromotionBanner'

export default {
  props: {
    stuck: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    isShop: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    banner: {
      $stuck: {
        borderTopWidth(value) {
          return value ? 1 : 0
        },
        borderBottomWidth(value) {
          return value ? 0 : 1
        }
      },
      $dark: {
        backgroundColor(value) {
          return value ? 'black' : 'grey-lightest'
        },
        color(value) {
          return value ? 'white' : null
        },
        borderColor(value) {
          return value ? 'black' : 'default'
        }
      },
      paddingX: 'sm',
      overflow: 'hidden'
    }
  },
  watch: {
    isShop: '$fetch'
  },
  async fetch() {
    const type_in = this.isShop ? ['shipping'] : ['shipping', 'price']

    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: PromotionBanner,
      variables: { where: { type_in }, orderBy: 'sortOrder_ASC' }
    })

    this.promotion = data[0]
  },
  data() {
    return {
      showImages: false,
      promotion: null
    }
  },
  computed: {
    title() {
      return this.promotion
        ? this.promotion.name
        : this.$t('bannerTitle')
    },
    text() {
      return this.promotion
        ? this.promotion.excerpt
        : this.$t('bannerText')
    },
    style() {
      if (!this.stuck) {
        return
      }

      const style = {
        position: 'sticky',
        bottom: this.$tracker.showControls ? '64px' : 0,
        zIndex: 49
      }

      return this.stuck ? style : null
    },
    buttonType() {
      return (this.dark || !this.$screen.lg) ? 'danger' : 'default'
    },
    showBanner() {
      return !this.$fetchState.pending && (!this.isShop || this.promotion)
    }
  },
  methods: {
    onClick() {
      const label = this.dark ? 'footer_banner' : 'header_banner'
      const data = { category: 'E-shop', label: label }

      this.$tracker.trackEvent('banner_click', data)
    }
  },
  mounted() {
    setTimeout(() => {
      this.showImages = true
    }, 500)
  }
}
